document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll(".rispo-search-form");

  forms.forEach((form) => {
    const toggle = form.querySelector(".rispo-search-form__toggle");
    const input = form.querySelector(".rispo-search-form__field");

    if (!toggle || !input) {
      return;
    }

    const openForm = () => {
      form.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      window.setTimeout(() => input.focus(), 120);
    };

    const closeForm = () => {
      if (!input.value.trim()) {
        form.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      }
    };

    toggle.addEventListener("click", () => {
      if (form.classList.contains("is-open")) {
        closeForm();
      } else {
        openForm();
      }
    });

    document.addEventListener("click", (event) => {
      if (!form.contains(event.target)) {
        closeForm();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeForm();
      }
    });
  });
});
